import { LitElement, html, css, classMap } from 'lit-all'

class NovaWishlistButton extends LitElement {
  static properties = {
    _active: {
      state: false,
    },
  }

  constructor() {
    super()
  }

  onClick(e) {
    e.preventDefault()

    this._active = !this._active
  }

  render() {
    return html` <div
      class="${classMap({ 'is-active': this._active })}"
      @click="${this.onClick}"
    >
      <slot></slot>    <sl-badge>
      <p style="font-size: 10px;">{{ cart.item_count }}</p>
    </sl-badge>
    </div>`
  }

  static styles = css`
    :host {
      width: 25px;
      height: 25px;
      display: block;
      position: absolute;
      top: 1em;
      right: 1em;
      z-index: 2;
    }
    :host(:hover) {
      cursor: pointer;
    }
    ::slotted(svg) {
      transition: fill var(--nova-transition, 400ms) ease;
      fill: white;
    }
    .is-active ::slotted(svg) {
      fill: red;
    }
  `
}

customElements.define('nova-wishlist-button', NovaWishlistButton)
